import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

export const Header = ({ title = "", subtitle = "", showBackButton = true, onBack }) => {
  const handleBackButton = () => {
    if (onBack) {
      onBack(); 
    } else {
      window.history.back(); 
    }
  };


  return (
    <div className="Header-container">
     {showBackButton && (
        <div className="Header-backbutton-wrapper">
          <div className="Header-backbutton" onClick={handleBackButton}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </div>
        </div>
      )}
      <div className="Header-content-wrapper">
        <div className="Header-text-wrapper">
          <div className="Header-title">
            <p>{title}</p>
          </div>
          <div className="Header-subtitle">
            <p>{subtitle}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
